import { Component, EventEmitter, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { CustomizeTableColumnsComponent } from "../../../customize-table-columns/customize-table-columns.component";
import { TableSearchComponent } from "../../../table-search/table-search.component";
import { DownloadType } from "../../../../constant/common-table";
import { FilterItem, TableColumn } from "../../../../models/common-table";

@Component({
  selector: "app-common-table-toolbar",
  standalone: true,
  imports: [CommonModule, CustomizeTableColumnsComponent, TableSearchComponent],
  templateUrl: "./common-table-toolbar.component.html",
})
export class CommonTableToolbarComponent {
  @Input() showColumnSelectAccordion: boolean = true;
  @Input() showFilterAccordion: boolean = true;
  @Input() columns: TableColumn[] = [];
  @Input() loading: boolean = false;
  @Input() selectableRows: boolean = false;
  @Input() disableDownload: boolean = false;
  @Input() dynamicPagination: boolean = false;
  @Input() rowsLength: number = 0;
  @Input() lowerCaseInput: boolean = true;
  @Input() filterItems: FilterItem[] = [];
  @Input() tableName: string = "";

  @Output() columnSelectionChanged: EventEmitter<Partial<TableColumn>[]> = new EventEmitter<Partial<TableColumn>[]>();
  @Output() filtersChanged: EventEmitter<FilterItem[]> = new EventEmitter<FilterItem[]>();
  @Output() downloadEvent: EventEmitter<DownloadType> = new EventEmitter<DownloadType>();
}
